class QuantityBundle {
  constructor(root) {
    this.root = root;
    this.form = root.closest('form[action*="/cart/add"]');
    this.quantityInput = this.form?.querySelector('[data-product-quantity]');
    this.variantSelect = this.form?.querySelector('[data-variant-select]');
    this.variantInput = this.form?.querySelector('[data-variant-id]');
    this.radios = [...root.querySelectorAll('[data-bundle-option]')];
    this.status = root.querySelector('[data-bundle-status]');
    this.radios.forEach(radio => radio.addEventListener('change', () => this.update()));
    this.variantSelect?.addEventListener('change', () => this.update());
    document.addEventListener('cart:updated', event => this.syncFromCart(event.detail));
    this.update();
  }

  variant() {
    const source = this.variantSelect?.selectedOptions[0] || this.variantInput;
    return {
      id: Number(source?.value || 0),
      price: Number(source?.dataset.price || 0),
      comparePrice: Number(source?.dataset.comparePrice || 0)
    };
  }

  selectedQuantity() {
    return Number(this.radios.find(radio => radio.checked)?.value || 1);
  }

  update() {
    const variant = this.variant();
    const quantity = this.selectedQuantity();
    if (this.quantityInput) this.quantityInput.value = quantity;

    this.root.querySelectorAll('[data-bundle-total]').forEach(total => {
      const optionQuantity = Number(total.dataset.quantity);
      total.textContent = UltraDisco.money(variant.price * optionQuantity);
      const card = total.closest('.quantity-bundle__card');
      const saving = card.querySelector('[data-bundle-saving]');
      const realSaving = Math.max(0, (variant.comparePrice - variant.price) * optionQuantity);
      if (saving) {
        saving.hidden = realSaving <= 0;
        saving.querySelector('span').textContent = realSaving > 0 ? UltraDisco.money(realSaving) : '';
      }
      card.querySelector('[data-bundle-unit]').textContent = UltraDisco.money(variant.price);
    });

    const sticky = document.querySelector('#StickyProductForm');
    if (sticky) {
      sticky.querySelector('[name="id"]').value = variant.id;
      sticky.querySelector('[name="quantity"]').value = quantity;
    }
    const stickyQuantity = document.querySelector('[data-sticky-quantity]');
    const stickyTotal = document.querySelector('[data-sticky-total]');
    if (stickyQuantity) stickyQuantity.textContent = quantity;
    if (stickyTotal) stickyTotal.textContent = UltraDisco.money(variant.price * quantity);
    if (this.status) this.status.textContent = `${quantity} unità selezionate. Totale ${UltraDisco.money(variant.price * quantity)}.`;
    document.dispatchEvent(new CustomEvent('bundle:change', {detail: {quantity, variantId: variant.id}}));
  }

  syncFromCart(cart) {
    if (!cart?.items) return;
    const variantId = this.variant().id;
    const quantity = cart.items.filter(item => item.variant_id === variantId).reduce((sum, item) => sum + item.quantity, 0);
    const matching = this.radios.find(radio => Number(radio.value) === quantity);
    if (matching) {
      matching.checked = true;
      this.update();
    } else if (quantity > 0) {
      this.radios.forEach(radio => { radio.checked = false; });
      if (this.quantityInput) this.quantityInput.value = quantity;
      if (this.status) this.status.textContent = `${quantity} unità presenti nel carrello; quantità personalizzata.`;
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-quantity-bundle]').forEach(root => new QuantityBundle(root));
});
